import React, { useState } from 'react';
import axios from 'axios'
import Registerpic from '../../../assets/images/register.svg'
import { toast as superToast } from 'bulma-toast'

function Register() {

    const [fname, setfname] = useState("")
    const [lname, setlname] = useState("")
    const [email, setemail] = useState("")
    const [nic, setnic] = useState("")
    const [birth, setbirth] = useState("")
    const [age, setage] = useState("")
    const [gender, setgender] = useState("")
    const [mobile, setmobile] = useState("")
    const [password, setpassword] = useState("")
    const [confpassword, setconfpassword] = useState("")

    function sendData(e) {
        e.preventDefault();

        if (confpassword !== password) {
            superToast({
                message: "Password Doesn't match",
                type: 'is-danger',
                dismissible: true,
                position: "top-center",
                animate: { in: 'fadeIn', out: 'fadeOut' },
            })
            return
        }

        const newUser = {
            fname,
            lname,
            email: email.toLowerCase(),
            nic,
            birth,
            age,
            gender,
            mobile,
            password
        };

        axios
            .post(`${process.env.REACT_APP_API_LINK_PREFIX}api/user/signup`, newUser)
            .then(() => {
                superToast({
                    message: 'User Create Successfully ',
                    type: 'is-success',
                    dismissible: true,
                    position: "top-center",
                    animate: { in: 'fadeIn', out: 'fadeOut' },
                })
                window.location.href = '/login';
            })
            .catch((err) => {
                superToast({
                    message: 'Email Already Exists',
                    type: 'is-danger',
                    dismissible: true,
                    position: "top-center",
                    animate: { in: 'fadeIn', out: 'fadeOut' },
                })
                console.log(err)
            });
    }

    return (
        <section className="hero is-fullheight-with-navbar">
            <div style={{ padding: '2rem 1rem' }}>
                <div className="container">
                    <div className="columns is-vcentered">
                        <div className="column is-5">
                            <figure className="image">
                                <img src={Registerpic} alt="Pipeline SVG" />
                            </figure>
                        </div>
                        <div className="column is-7">
                            <form onSubmit={sendData}>
                                <h1 className='title is-2 has-text-centered'>Register</h1>

                                <div className='columns is-justify-content-center is-mobile mb-0'>
                                    <div className='column is-5'>
                                        <div className="field">
                                            <label className="label">First Name</label>
                                            <div className="control">
                                                <input required className="input is-info" type="fname" placeholder='First Name' onChange={(e) => { setfname(e.target.value) }} />
                                            </div>
                                        </div>
                                    </div>

                                    <div className='column is-5'>
                                        <div className="field">
                                            <label className="label">Last Name</label>
                                            <div className="control">
                                                <input required className="input is-info" type="text" placeholder='Last Name' onChange={(e) => { setlname(e.target.value) }} />
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className='columns is-justify-content-center is-mobile mb-0'>
                                    <div className='column is-10'>
                                        <div className="field">
                                            <label className="label">Email</label>
                                            <div className="control">
                                                <input required className="input is-info" type="email" placeholder='Email' onChange={(e) => { setemail(e.target.value) }} />
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className='columns is-justify-content-center is-mobile mb-0'>
                                    <div className='column is-10'>
                                        <div className="field">
                                            <label className="label">NIC</label>
                                            <div className="control">
                                                <input required className="input is-info" type="text" placeholder='NIC' onChange={(e) => { setnic(e.target.value) }} />
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className='columns is-justify-content-center is-mobile  mb-0'>
                                    <div className='column is-5 '>
                                        <div className="field">
                                            <label className="label">Date Of Birth</label>
                                            <div className="control">
                                                <input required className="input is-info" type="date" onChange={(e) => { setbirth(e.target.value) }} />
                                            </div>
                                        </div>
                                    </div>

                                    <div className='column is-5'>
                                        <div className="field">
                                            <label className="label">Age</label>
                                            <div className="control">
                                                <input required className="input is-info" type="text" placeholder='Age' onChange={(e) => { setage(e.target.value) }} />
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className='columns is-justify-content-center is-mobile mb-0'>
                                    <div className='column is-5'>
                                        <div className="field">
                                            <label className="label">Mobile</label>
                                            <div className="control">
                                                <input className="input is-info" type="tel" placeholder='Mobile number' onChange={(e) => { setmobile(e.target.value) }} />
                                            </div>
                                        </div>
                                    </div>
                                    <div className='column is-5'>
                                        <div className="field">
                                            <label className="label">Gender</label>
                                            <div className='is-flex'>
                                                <div className="control">
                                                    <input className='mr-1' name="gender" type="radio" value="male" onChange={(e) => { setgender(e.target.value) }} />
                                                    Male
                                                </div>
                                                <div className="control ml-5">
                                                    <input className='mr-1' name="gender" type="radio" value="female" onChange={(e) => { setgender(e.target.value) }} />
                                                    Female
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>


                                <div className='columns is-justify-content-center is-mobile mb-0'>
                                    <div className='column is-5'>
                                        <div className="field">
                                            <label className="label">Password</label>
                                            <div className="control">
                                                <input required className="input is-info" type="password" pattern="(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}" placeholder='Password' onChange={(e) => { setpassword(e.target.value) }} />
                                            </div>
                                        </div>
                                    </div>

                                    <div className='column is-5'>
                                        <div className="field">
                                            <label className="label">Re-Password</label>
                                            <div className="control">
                                                <input required className="input is-info" type="password" pattern="(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}" placeholder=' Confirm Password' onChange={(e) => { setconfpassword(e.target.value) }} />
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <h1 className='has-text-centered'><input type='submit' value='Create' className='button is-info' /></h1>

                            </form>
                        </div>
                    </div>
                </div>
            </div>

        </section>
    )

}

export default Register;